<div class="sidebar sidebar-offcanvas" [ngClass]="sidebarclass" data-color="primary" [attr.data-background-color]="backGroundColor" 
    data-image="../assets/img/sidebar.jpg">
    <!--     <div class="nav menu-toggler sidebar-toggler bg-primary" (click)="toggleSideBar()">
        <span>show</span>
    </div> -->
    <nav id="sidebar" class="active">
        <ul class="nav menu2lines list-unstyled components">

            <ng-container *ngFor="let menuItem of menuItems">
                <ng-container *ngIf="menuItem.header==null">


                    <li routerLinkActive="active" class="nav-item withpointer {{menuItem.class}}" 
                        matTooltip="{{menuItem?.tooltip}}">
                        <a class="nav-link" (click)="navigateTo(menuItem)" [routerLink]="menuItem.path">
                            <ng-container *ngIf="menuItem.type=='STACKED'">
                                <div class="menu-icon stacked">
                                    <i class="menu-icon fas fa-solar-panel"></i>
                                    <i class="menu-icon fas fa-globe-americas"></i>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="menuItem.type=='STD'">
                                <i class="menu-icon {{menuItem.icon}}"></i>
                            </ng-container>

                            <span class="menu-title">{{menuItem.title}}</span>
                        </a>
                    </li>

                </ng-container>
                <ng-container *ngIf="menuItem.header==true">
                    <li class="nav-item nav-title {{menuItem.class}}">
                        <i *ngIf="menuItem.icon" class="menu-icon {{menuItem.icon}}"></i>
                        <span class="menu-title">{{menuItem.title}}</span>
                    </li>

                </ng-container>
            </ng-container>

        </ul>
    </nav>


    <div>

        <div class="powered">
            <table>
                <tr>
                    <td>
                        <div class="powered-img">
                            <img src="/assets/img/brand/logo.png" />
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="powered-text">Powered by GeoAI</div>
                    </td>
                </tr>
                <tr *ngIf="showVerifierLogo">
                    <td>
                        <div class="powered-img">
                            <img src="/assets/img/brand/logo-exanter-30x30.png" />
                        </div>
                    </td>
                </tr>
                <tr *ngIf="showVerifierLogo">
                    <td>
                        <div class="powered-text">Verified by Exanter</div>
                    </td>


                </tr>
            </table>
        </div>

    </div>

    <!-- <div class="sidebar-background" style="background-image: url(../assets/img/sidebar.png)"></div> -->
</div>